export interface IOnBoardingState {
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly inFlightUser?: any;
  readonly hasUserLoggedIn?: boolean;
  readonly hasUserCreated?: boolean;
  readonly verificationSuccessful?: boolean;
  readonly awaitingUserVerification?: boolean;
  readonly continueToDashboard?: boolean;
  readonly orgConnectionCode?: string;
  readonly backendErrors?: any;
  readonly sports?: any[];
}

export interface IOnBoardingSelector extends IOnBoardingState {
  readonly currentOnBoarding?: any;
  readonly currentFormOnBoarding?: any;
  readonly onBoardingsFilteredByTagInSelectFormat?: any;
  readonly onBoardingsByIdInSelectFormat?: any;
  readonly onBoardingsFilteredByOrganisationInSelectFormat?: any;
}

export enum OnBoardingActionTypes {
  PERSIST_HYDRATED = 'persist/REHYDRATE',
  GET_SPORTS_SUCCESS = 'redux-app/onBoarding/GET_SPORTS_SUCCESS',
  UPDATE_ADMIN_DATA = 'redux-app/onBoarding/UPDATE_ADMIN_DATA',
  OPERATION_PENDING = 'redux-app/onBoarding/OPERATION_PENDING',
  OPERATION_FINISHED = 'redux-app/onBoarding/OPERATION_FINISHED',
  USER_CREATION_SUCCESS = 'redux-app/onBoarding/USER_CREATION_SUCCESS',
  USER_CREATION_FAILED = 'redux-app/onBoarding/USER_CREATION_FAILED',
  VERIFICATION_SUCCESS = 'redux-app/onBoarding/VERIFICATION_SUCCESS',
  VERIFICATION_FAILED = 'redux-app/onBoarding/VERIFICATION_FAILED',
  USER_LOGIN_SUCCESS = 'redux-app/onBoarding/USER_LOGIN_SUCCESS',
  USER_LOGIN_FAILED = 'redux-app/onBoarding/USER_LOGIN_FAILED',
  USER_CREATE_TEAM_SUCCESS = 'redux-app/onBoarding/USER_CREATE_TEAM_SUCCESS',
  USER_CREATE_SUCCESS = 'redux-app/onBoarding/USER_CREATE_SUCCESS',
  BANK_ACCOUNT_CREATION_FAILED = 'redux-app/onBoarding/BANK_ACCOUNT_CREATION_FAILED',
  CONTINUE_TO_DASHBOARD = 'redux-app/onBoarding/CONTINUE_TO_DASHBOARD',
  LOAD_GET_STARTED = 'redux-app/onBoarding/LOAD_GET_STARTED',
  CREATE_NEW_USER_REQUESTED = 'redux-app/onBoarding/CREATE_NEW_USER_REQUESTED',
  CREATE_USER_AND_TEAM_REQUESTED = 'redux-app/onBoarding/CREATE_USER_AND_TEAM_REQUESTED',
  LOGIN_USER_REQUESTED = 'redux-app/onBoarding/LOGIN_USER_REQUESTED',
  VERIFY_USER_REQUESTED = 'redux-app/onBoarding/VERIFY_USER_REQUESTED',
  CREATE_BANK_ACCOUNT_REQUESTED = 'redux-app/onBoarding/CREATE_BANK_ACCOUNT_REQUESTED',
  RESET_ONBOARDING = 'redux-app/onBoarding/RESET_ONBOARDING',
}

export default null;
